export const compare = (obj1, obj2, key) => {
  var val1 = obj1[key];
  var val2 = obj2[key];
  if (val1 < val2) {
      return -1;
  } else if (val1 > val2) {
      return 1;
  } else {
      return 0;
  }            
} 

export const sum = (arr, key) => {
  let total = 0;
  if (key) {
    arr.forEach(x=> {
      total = x[key] + total;
    });
  } else {
    arr.forEach(x=> {
      total = x + total;
    });
  }
  return total;
}